import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {ROLE_SUPER_ADMINISTRATOR} from '../../models/user/user-info.model';
import {RoleModel} from '../../models/roles/role.model';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  private readonly baseUrl = `${environment.backend.url}/api/role/v1`;

  constructor(private readonly http: HttpClient) {}

  public getRoles(): Observable<RoleModel[]> {
    return this.http.get<RoleModel[]>(`${this.baseUrl}`).pipe(
      map(roles => roles.filter(r => r.normalizedName !== ROLE_SUPER_ADMINISTRATOR))
    );
  }

}
